<template>
    <div class="md-layout-item md-size-100">
        <PageTitle title="RAID" />
        <div v-if="existeRoleRaid">
            <!--<form ref="frmRaid" action="https://faturamentodev.krthomolog.com.br/Eagles/Home/RaidIntegration" target="raid-iframe" method="post">
                <input ref="inputToken" type="hidden" name="token">
            </form>-->
            <form ref="frmRaid" :action="`${urlNegociacaoCobranca}`" target="raid-iframe" method="post">
                <input ref="inputToken" type="hidden" name="token">
            </form>
            <iframe title="raid-iframe" name="raid-iframe" class="md-iframe" allowfullscreen v-show="!showLoading"></iframe>
            <Loading v-bind:show="showLoading"></Loading>
        </div>
    </div>
</template>
<script>
    import Raid from '@/services/RaidService.js';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';

    export default {
        components: {
            PageTitle,
            Loading
        },
        data() {
            return {
                aluno: null,
                showLoading: false,
                dadosAba: null,
                token: "",
                urlNegociacaoCobranca: ""
            }
        },
        computed: {
            existeRoleRaid() {
                if (this.msal.isAuthenticated && this.msal?.user?.idTokenClaims?.roles?.length) {
                    return this.msal.user.idTokenClaims.roles.includes("RAID_Acessar")
                } else {
                    return false
                }
            }
        },
        watch: {
            token(tk) {
                this.$refs.inputToken.value = tk;
                this.$refs.frmRaid.submit();
            }
        },
        mounted() {
            this.urlNegociacaoCobranca = this.$Configs.urlNegociacaoCobranca;

            this.raidService = new Raid(this);
               
            //Verifica se o Feature Toggle ta desligado
            if (!this.$featureToggle.INTEGRA_MENU_RAID) {
                this.$modal.alert(this.$msgFeatureToggle);
            }
            else {
                //Verifica se tem aluno selecionado
                if (!sessionStorage.Aluno) {
                    this.$modal.alert("Não foi possível encontrar o aluno não selecionado, escolha um aluno na página <a href='" + this.$Configs.urlServiceNow + "pad?id=pda_master'>Pesquisar aluno</a> no PAD e tente novamente.",
                        "",
                        () => { window.location = this.$Configs.urlServiceNow });
                } else {

                    let a = JSON.parse(sessionStorage.Aluno);
                    //Coloca o perfil de aluno disponível na variável aluno
                    if (a.PerfilAluno) {
                        this.aluno = a.PerfilAluno;
                        //Verifica se os dados da Aba ja esta carregado
                        this.carregar();
                    }
                    else
                        this.$modal.alert("Não foi possível encontrar o aluno não selecionado, escolha um aluno na página <a href='" + this.$Configs.urlServiceNow + "pad?id=pda_master'>Pesquisar aluno</a> no PAD e tente novamente.",
                            "",
                            () => { window.location = this.$Configs.urlServiceNow });
                }
            }
        },
        methods: {
            carregar() {
                //Popula os dados da aba
                if (this.existeRoleRaid) {
                    this.showLoading = true;
                    this.raidService.RetornaToken({
                        Type: (this.aluno.sistema == 'COLABORAR' ? 'CLB' : 'OLP'),
                        CodigoAluno: (this.aluno.sistema == 'COLABORAR' ? this.aluno.ra : this.aluno.codigoAluno),
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        User: this.msal.user.userName.split("@")[0],
                        Source: "SistemaIntegra"
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados.token;
                                this.token = data.dados.token.access_Token;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                } else {
                    this.$modal.alert("Seu usuário não possui privilégios para acessar esta página.");
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-iframe {
        width: 100%;
        height: 500px;
    }
</style>
